import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Sending } from './Sending';

export const Message = types.compose(
  BaseEntity,
  types.model('Message', {
    messageId: types.identifierNumber,
    title: types.string,
    body: types.string,
    type: types.maybe(types.string),
    sendings: types.optional(types.array(Sending), []),
    isSender: types.maybe(types.boolean),
    isBeneficiary: types.maybe(types.boolean),
    statusCode: types.maybe(types.string),
    statusName: types.maybe(types.string),
    senderName: types.maybe(types.string),
    recipientName: types.maybe(types.string),
  }),
);
